import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconFilter';
/** Renders an SVG icon. */
const SvgFilter = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M17.001 21h-2.002l.001.03v6.352l2-1v-5.353zM24 8H8v2.313a1 1 0 0 0 .21.615l5.947 7.645q.158.206.287.429L14.5 19h3l.055.002a4 4 0 0 1 .288-.429l5.946-7.645a1 1 0 0 0 .211-.615zm2 2.313c0 .667-.222 1.316-.632 1.842l-5.947 7.647A2 2 0 0 0 19 21.029v5.817c0 .473-.268.906-.691 1.118l-3.5 1.75A1.25 1.25 0 0 1 13 28.596v-7.567a2 2 0 0 0-.42-1.227l-5.948-7.647A3 3 0 0 1 6 10.314V7a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1z"
      />
    </svg>
  );
};
SvgFilter.displayName = displayName;
export default SvgFilter;
